module.exports = __webpack_public_path__ + "static/media/t4.0fd9f154.jpg";